import React, { useState } from "react";
import { Paper, Typography, Divider, Grid, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import EditOrderReporting from "./EditOrderReporting";

const OrderReportingView = ({ order }) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const handleEditClick = () => {
    order.orderNumber = String(order.orderNumber);
    setIsEditDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsEditDialogOpen(false);
  };

  const handleSave = (updatedOrder) => {
    setIsEditDialogOpen(false);
  };

  if (!order) {
    return <div>No order data available.</div>;
  }

  return (
    <>
      <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
        <Grid container alignItems="center" >
          <Typography variant="h5" sx={{ mb: 2 }}>
            Reporting Details
          </Typography>
          <IconButton aria-label="edit" onClick={handleEditClick} style={{ color: "orange", marginLeft:"10px", paddingBottom:"20px" }}>
            <EditIcon />
          </IconButton>
        </Grid>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Reporting Name: {order.reportingName}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report Contact: {order.reportContact}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report Address: {order.reportAddress}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report Address 2: {order.reportAddress2}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report City: {order.reportCity}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report State: {order.reportState}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report Zip: {order.reportZip}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report Phone: {order.reportPhone}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report Fax: {order.reportFax}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Report Email: {order.reportEmail}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {isEditDialogOpen && (
        <EditOrderReporting
          open={isEditDialogOpen}
          order={order}
          onSave={handleSave}
          onClose={handleDialogClose}
        />
      )}
    </>
  );
};

export default OrderReportingView;
